import React from "react";
import { arrayOf, number, shape, string } from "prop-types";
import { Card } from "uikit/components";
import styles from "./RegionTrainingPlansView.module.styl";
import RegionTrainingPlansRow from "components/regionSummary/RegionTrainingPlansRow/RegionTrainingPlansRow";

export default function RegionTrainingPlansView({ regionId, schoolTrainingPlans }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="region_training_plans_form">
                <div className={styles.schoolName}>Название организации</div>
                <div className={styles.municipalityName}>Район / Населённый пункт</div>
                <div className={styles.trainingPlanFilling}>Наполнение</div>
            </div>
            <div>
                {schoolTrainingPlans?.map((item) => (
                    <RegionTrainingPlansRow
                        key={item.schoolId}
                        schoolTrainingPlan={item}
                        regionId={regionId}
                    />
                )) ?? []}
            </div>
        </Card>
    );
}

RegionTrainingPlansView.propTypes = {
    regionId: number.isRequired,
    schoolTrainingPlans: arrayOf(
        shape({
            schoolId: number.isRequired,
            schoolName: string.isRequired,
            municipalityName: string,
            trainingPlanFilling: number.isRequired,
        }),
    ),
};
